import {
    createBrowserRouter,
    RouterProvider
} from 'react-router-dom';


import {Notifications} from '@mantine/notifications';
import {UserAttributesContextProvider} from "./context/UserAttributesContext.tsx";

import {ModalsProvider} from "@mantine/modals";

import '@mantine/core/styles.css';
import '@mantine/dates/styles.css';
import '@mantine/notifications/styles.css';
import 'mantine-datatable/styles.css';
import '@flexinet/ui-components/style.css'

import {MantineProvider} from "@mantine/core";
import {AnalyticsAuthListener} from "@flexinet/analytics-components";
import {
    createAuthAwareQueryClient,
    SessionGuardProvider
} from "@flexinet/auth-components";
import {theme} from "./theme.ts";
import {AuthProvider} from "./context/AuthContext.tsx";
import {routesConfig} from "./config/routes.tsx";
import {VerifiedPermissionsProvider} from "./context/VerifiedPermissionsProvider.tsx";
import {actions} from "./config/rbac/actions.ts";
import {QueryClientProvider} from '@tanstack/react-query';

const queryClient = createAuthAwareQueryClient({
    defaultOptions: {
        queries: {
            staleTime: 1000 * 60 * 5,
            refetchOnWindowFocus: false,
        },
    },
});


export const App = () => {

    const router = createBrowserRouter(routesConfig)

    return (
        <MantineProvider theme={theme}>
            <SessionGuardProvider>
                <QueryClientProvider client={queryClient}>
                    <AuthProvider>
                        <AnalyticsAuthListener/>
                        <UserAttributesContextProvider>
                            <VerifiedPermissionsProvider actions={actions}>
                                <ModalsProvider>
                                    <Notifications position={'bottom-left'}/>
                                    <RouterProvider router={router}/>
                                </ModalsProvider>
                            </VerifiedPermissionsProvider>
                        </UserAttributesContextProvider>
                    </AuthProvider>
                </QueryClientProvider>
            </SessionGuardProvider>
        </MantineProvider>
    );
}
